import React from "react";
import ajax from "./../lib/ajax.js";
import moment from 'moment';
import context from "./../lib/context.js";
import AccrualItem from "./accrual/accrual-item.jsx";
import AccrualItemMobile from "./accrual/accrual-item-mobile.jsx";

export default class PeopleAccrualHomeOld extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accrualSummary: [],
        }
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        let self = this;
        ajax.vm()
            .get('people/get-accrual-summary')
            .then(
                function (res) {
                    const result = res.data;
                    self.setState({ accrualSummary: result });
                    context.message({ show: false });
                })
            .catch(function (err) {
                self.setState({ accrualSummary: [] });
                let data = err.response ? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }
    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        let mobile = this.isIos() || this.isAndroid();
        if (this.state.accrualSummary.length > 0) {
            if (mobile) {
                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <h2 className="text-center ap-title-mobile">PTO/Sick Leave Balance</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12" style={{ color: "#000000" }}>
                                <h4 className="text-center">Anniversary Date <b>{moment(this.state.accrualSummary[0].leaveYearEndDate).add("d", 1).format("MMM D, YYYY")}</b></h4>
                            </div>
                        </div>
                        <AccrualItemMobile accrualSummary={this.state.accrualSummary} />
                    </div>
                );
            } else {
                return (
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="text-center ap-title">PTO/Sick Leave Balance</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12" style={{ color: "#000000" }}>
                                <h4 className="text-center">Anniversary Date <b>{moment(this.state.accrualSummary[0].leaveYearEndDate).add("d", 1).format("MMM D, YYYY")}</b></h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <AccrualItem accrualSummary={this.state.accrualSummary} />
                            </div>
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="text-center ap-title">PTO/Sick Leave Balance</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 ap-paystubgrid-empty">
                            No Details found !
                            </div>
                    </div>
                </div>
            );
        }

    }
}
